import { FieldLogo } from '../../components/index.js';

/**
 * Field dimensions:
 *  36 x 70 (yards)
 *  */
const SixesFullFieldBackdrop: FC<any> = ({ fieldViewport, backgroundImage, viewOptions }) => {
    const fieldWidth = 36;
    const fieldHeight = 70;

    const topGoalY = 10;
    const bottomGoalY = 60;

    return (
        <g className="field-backdrop">
            <g className="optional-lines">
                {/* Optional field lines */}
                {viewOptions.fieldLines?.GOAL ? (
                    <>
                        <line
                            x1={fieldViewport.getPixelX(0)}
                            y1={fieldViewport.getPixelY(bottomGoalY)}
                            x2={fieldViewport.getPixelX(fieldWidth)}
                            y2={fieldViewport.getPixelY(bottomGoalY)}
                        />
                        <line
                            x1={fieldViewport.getPixelX(0)}
                            y1={fieldViewport.getPixelY(topGoalY)}
                            x2={fieldViewport.getPixelX(fieldWidth)}
                            y2={fieldViewport.getPixelY(topGoalY)}
                        />
                    </>
                ) : null}
            </g>

            {/* Field Outline */}
            <rect
                x={fieldViewport.flippedX ? fieldViewport.getPixelX(fieldWidth) : fieldViewport.getPixelX(0)}
                y={fieldViewport.flipped ? fieldViewport.getPixelY(fieldHeight) : fieldViewport.getPixelY(0)}
                width={fieldViewport.getPixelLength(fieldWidth)}
                height={fieldViewport.getPixelLength(fieldHeight)}
                fill="none"
            />

            {/* Top Logos */}
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: 6, y: 25 }}
                size={8}
                rotation={90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: fieldWidth - 6, y: 25 }}
                size={8}
                rotation={-90}
            />

            {/* Bottom Logos */}
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: 6, y: fieldHeight - 25 }}
                size={8}
                rotation={90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: fieldWidth - 6, y: fieldHeight - 25 }}
                size={8}
                rotation={-90}
            />

            {/* Center */}
            <line
                x1={fieldViewport.getPixelX(0)}
                y1={fieldViewport.getPixelY(fieldHeight / 2)}
                x2={fieldViewport.getPixelX(fieldWidth)}
                y2={fieldViewport.getPixelY(fieldHeight / 2)}
            />

            <circle
                cx={fieldViewport.getPixelX(fieldWidth / 2)}
                cy={fieldViewport.getPixelY(fieldHeight / 2)}
                r={fieldViewport.getPixelLength(5)}
                fill="none"
            />

            {/* Restart markers */}
            <circle
                cx={fieldViewport.getPixelX(fieldWidth - 5)}
                cy={fieldViewport.getPixelY(fieldHeight / 2 + 2)}
                r={fieldViewport.getPixelLength(0.5)}
                fill="none"
            />
            <circle
                cx={fieldViewport.getPixelX(fieldWidth - 5)}
                cy={fieldViewport.getPixelY(fieldHeight / 2 - 2)}
                r={fieldViewport.getPixelLength(0.5)}
                fill="none"
            />

            {/* Substitution Area */}
            <line
                x1={fieldViewport.getPixelX(fieldWidth)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 - 5)}
                x2={fieldViewport.getPixelX(fieldWidth + 2)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 - 5)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth + 2)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 - 5)}
                x2={fieldViewport.getPixelX(fieldWidth + 2)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 + 5)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 + 5)}
                x2={fieldViewport.getPixelX(fieldWidth + 2)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 + 5)}
            />

            <text
                dx={
                    fieldViewport.flippedX
                        ? fieldViewport.getPixelX(10) - 5
                        : fieldViewport.getPixelX(fieldWidth - 10) - 5
                }
                dy={fieldViewport.flipped ? fieldViewport.getPixelY(0) - 5 : fieldViewport.getPixelY(fieldHeight) - 5}
                textAnchor="end"
                strokeWidth="0"
                fill="#aaa"
                fontSize=".8em"
            >
                LacrosseLab.com
            </text>
        </g>
    );
};

export default SixesFullFieldBackdrop;
